import React, { useState } from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./form.data.form";
import Autocomplete from "../../utils/InputAutocomplete";
import {
  Subtitle,
  PdfContainer,
  ContainerTickets,
  EmptyContainer,
  CopiesContainer,
  CopiesText,
  LabelEmpty,
  FormCard,
  ResetButton,
  ConfirmButton,
} from "./form.styled";
import { useDispatch } from "react-redux";
import { show } from "redux-modal";
import PdfView from "./pdf.view";
import html2PDF from "jspdf-html2canvas";
import moment from "moment-timezone";
import InputSelect from "../../utils/InputSelect";
import {
  STEP_TYPES,
  TICKET_TYPE_ALMOND_CAMP,
  TYPES,
} from "../../../constants/index";
import TicketDefault from "../tickets/default.view";
import AlmdCmpTicket from "../tickets/almondCampaign.view";

const NewEvaluationForm = (props) => {
  const { t } = useTranslation();
  const [copies, setCopies] = useState(null);
  const [selectedFarm, setSelectedFarm] = useState(null);
  const {
    handleSubmit,
    cancelAction,
    onFilterFinca,
    data,
    resetForm,
    onSelectStep,
    onSelectType,
    onEmptyTicket,
    emptyTicket,
    farms,
    parcels,
    setSections,
    setData,
  } = props;
  const dispatch = useDispatch();

  const renderListFinca = (item) => {
    return item.name;
  };
  const setArraySections = async (value) => {
    const farm = farms.find((item) => item.uuid === value);
    const parcels = farm?.parcels || [];
    const sectionsMap = new Map();

    for (const parcel of parcels) {
      for (const section of parcel.sections || []) {
        sectionsMap.set(section.uuid, section);
      }
    }

    const sections = Array.from(sectionsMap.values());
    const data = {
      uuid: farm?.uuid,
      farmName: farm?.name,
      crop: farm?.crop,
      sections: sections,
    };
    // keep `data` as an array of farms to match other usages (e.g. data.sections)
    setData(data);
  };

  const printTags = async (data) => {
    const date = new Date();
    const pages = document.getElementsByClassName("page");
    await html2PDF(pages, {
      jsPDF: {
        format: "a4",
        unit: "mm",
      },
      imageType: "image/jpeg",
      output: `etiquetas_${moment(date).format("DDMMYYYYhhmmss")}`,
    });
  };

  const onSelectCopies = (event) => {
    setCopies(event.target.value);
  };

  const generateTagsTemplate = (data) => {
    return (
      <>
        <PdfContainer>
          <div
            id="pdfData"
            className="mt4"
            style={{
              backgroundColor: "#fff",
              width: "210mm",
              minHeight: "297mm",
              margin: "auto",
            }}
          >
            <PdfView data={data} empty={emptyTicket}></PdfView>
          </div>
        </PdfContainer>
        <div className="row mt-3">
          <div className="col-12 text-center">
            <button
              type="button"
              className="btn btn-md btn-primary"
              title={t("download")}
              onClick={() => printTags(data)}
            >
              {t("download")}
            </button>
          </div>
        </div>
      </>
    );
  };

  const showModalTags = () => {
    let finalData = JSON.parse(JSON.stringify(data));
    if (copies) {
      for (let index = 0; index < Number(copies) - 1; index++) {
        finalData[0].sections.push(data.sections[0]);
      }
    }
    dispatch(
      show("ModalForm", {
        body: <>{generateTagsTemplate(finalData)}</>,
        className: "tagModal",
      }),
    );
  };

  const renderSection = (finca) => {
    let ticketType = "default";
    // if (data.ticketType) {
    //   ticketType = data.ticketType;
    // }
    return data.sections.map((sec) => {
      return (
        <div key={`${sec.uuid}_${sec.name}`} className="col">
          <div className="row no-margin">
            {ticketType === "default" && (
              <TicketDefault
                sec={sec}
                data={data}
                empty={emptyTicket}
              ></TicketDefault>
            )}
            {ticketType === TICKET_TYPE_ALMOND_CAMP.code && (
              <AlmdCmpTicket
                sec={sec}
                finca={finca}
                empty={emptyTicket}
              ></AlmdCmpTicket>
            )}
          </div>
        </div>
      );
    });
  };

  const renderFinca = () => {
    // return data.sections.map((finca) => {
    return (
      <div
        key={data.uuid}
        className="row row-cols-1 row-cols-md-1 row-cols-lg-2"
      >
        {renderSection(data)}
      </div>
    );
    // });
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <FormCard>
            <form onSubmit={handleSubmit} autoComplete="off">
              <div className="row justify-content-center">
                <Subtitle className="col-11 col-md-11 mb-4">
                  {t("generate")}
                </Subtitle>
              </div>
              <div className="row justify-content-center">
                <div className="col-11 col-md-11">
                  <div className="row">
                    <div className="col-12 mt-2">
                      <Field
                        id="stepType"
                        name="stepType"
                        labelField={t("filterStepType")}
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="code"
                        onChangeValue={onSelectStep}
                        options={STEP_TYPES.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        classNamePrefix="dark"
                        classNameContainer="flex-grow-1"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 mt-2">
                      <Field
                        id="crop"
                        name="crop"
                        labelField={t("filterType")}
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="code"
                        onChangeValue={onSelectType}
                        options={TYPES.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        classNamePrefix="dark"
                        classNameContainer="flex-grow-1"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 mt-2">
                      <Field
                        id="farmUuid"
                        name="farmUuid"
                        labelField={t("filterFarms")}
                        component={InputSelect}
                        placeholder=""
                        optionLabel="name"
                        optionValue="uuid"
                        // onChangeValue={(value) => setSelectedFarm(value)}
                        // onChangeValue={(value) => {
                        //   setArraySections(value);
                        // }}
                        options={farms}
                        classNamePrefix="dark"
                        classNameContainer="flex-grow-1"
                      />
                    </div>
                  </div>{" "}
                  {/* <div className="row">
                    <div className="col-12 mt-2">
                      <Field
                        id="parcelUuid"
                        name="parcelUuid"
                        labelField={t("filterParcels")}
                        component={InputSelect}
                        placeholder=""
                        optionLabel="name"
                        optionValue="uuid"
                        onChangeValue={(value) => {
                          const parcel = parcels.find(
                            (item) => item.uuid === value,
                          );
                          setSections(parcel?.sections || []);
                          setData(parcel);
                        }}
                        options={parcels
                          ?.filter((item) => item.farmUuid === selectedFarm)
                          ?.map((item) => ({
                            ...item,
                            name: t(item.name),
                          }))}
                        classNamePrefix="dark"
                        classNameContainer="flex-grow-1"
                      />
                    </div>
                  </div> */}
                </div>
              </div>

              <div className="row justify-content-center mt-4">
                <div className="col-11 text-center">
                  <ResetButton
                    type="button"
                    onClick={() => cancelAction(resetForm)}
                    className="btn btn-md btn-cancel me-2"
                  >
                    {t("reset")}
                  </ResetButton>
                  <ConfirmButton
                    type="submit"
                    className="btn btn-md btn-primary me-2"
                  >
                    {t("getData")}
                  </ConfirmButton>
                </div>
              </div>
            </form>
          </FormCard>
        </div>
      </div>
      {data && (
        <>
          <div className="row justify-content-center mb-4">
            <Subtitle className="col-12 col-md-4 col-lg-3 text-start mb-3 mb-md-0 d-flex justify-content-center justify-content-md-start">
              {t("tickets")}
            </Subtitle>
            <div className="col-12 col-md-4 col-lg-7 d-flex align-items-center justify-content-md-end">
              <EmptyContainer className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  checked={emptyTicket}
                  id="emptyTickets"
                  onChange={(e) => onEmptyTicket(e.target.checked)}
                />
                <LabelEmpty className="form-check-label" htmlFor="emptyTickets">
                  {t("generateEmptyTicket")}
                </LabelEmpty>
              </EmptyContainer>
              {data && data.length === 1 && data.sections.length === 1 && (
                <CopiesContainer className="d-flex align-items-center">
                  <CopiesText>{t("copies")}:</CopiesText>
                  <select name="copies" onChange={(e) => onSelectCopies(e)}>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                  </select>
                </CopiesContainer>
              )}

              <button
                type="button"
                onClick={() => showModalTags()}
                className="btn btn-md btn-secondary me-2"
              >
                {t("generatePdf")}
              </button>
            </div>
          </div>
          <div className="row justify-content-center mb-5">
            <ContainerTickets className="col-12 col-md-8 col-lg-10">
              {renderFinca()}
            </ContainerTickets>
          </div>
        </>
      )}
    </>
  );
};

NewEvaluationForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
};

const NewEvaluationFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "NewEvaluationForm",
})(NewEvaluationForm);

export default NewEvaluationFormF;
